module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAUtJREFUSEvtlDFLhVAYht+jaUhLEXGJCBqipSGCpqKpvaWpQbiiR3Fwipr9AU1tfq6tjS1BRdEPiP7BXRT6BUkcTggJ5qXr9XKcyvUcn8fzvsePoeeH9czHHxKEYXgohLgiot0usU4VURAEe1LKewAfRDRQKuCcbzPGngAsA3hXKnBdd1PX9WcAq99frU7gOM66YRglfKMWiRqB53kDTdNK+FYjb8EYG/3WgZTylYhO6utjJYdhuCSEeASw06XMai8R/WCOCTjnL4yxg1ng5TutAt/3LwGc9SYowUEQkJSSzyJpPUEJjeNYy/P8Wkp52pB8AnibVHKapt7EkqvFOI7nsiy7AXCs/JpWwCiK5ouiuAVwpPxHqyS2bS9YlnUHYF/5qKgkw+Fw0TTNBwBrSmdRvSzHcVZM07xIkuS8y+2aalx3ATb3/gta0/sCEcBrGe21+X8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_return.png
// module id = 4Q89
// module chunks = 1